<script>
export default {
  name: "edit-button"
}
</script>
<template>
  <b-button variant="light" v-bind="$attrs">
    <slot>{{ $t('Edit') }}</slot>
  </b-button>
</template>

<style scoped lang="scss">
.btn {
  &.btn-light {
    background-color: white;
    color: #182230;

    border-color: #D0D5DD;
  }
}
</style>